<template>
  <div class="g-sidenav-show" style="background-color: #f0f6ff;">
    <div class="min-height-300 bg-dark position-absolute w-100"></div>
    <main class="main-content position-relative border-radius-lg">
      <HeaderMenu />
      <div class="container-fluid pt-6" style="min-height: 100vh;">
        <!-- Notificaciones -->
        <div class="position-fixed top-0 end-0 p-3" style="z-index: 1050;">
          <div v-for="(notification, index) in notifications" :key="index"
            :class="['alert', notification.class, 'alert-dismissible fade show']" role="alert">
            {{ notification.message }}
            <button type="button" class="btn-close" @click="closeNotification(index)"></button>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <div class="card">
              <div class="card-header d-flex align-items-center">
                <h6 class="mb-0">Tareas pendientes</h6>
                <button class="btn btn-primary btn-sm ms-auto" @click="cargarTareas" :disabled="cargando">
                  <span v-if="cargando" class="spinner-border spinner-border-sm me-2" role="status"></span>
                  Recargar
                </button>
              </div>
              <div class="card-body">
                <div v-if="cargando" class="text-center my-4">
                  <div class="spinner-border text-primary" role="status"></div>
                  <p class="text-muted mt-2">Cargando tareas...</p>
                </div>
                <div v-else>
                  <div v-if="tareasFiltradas.length === 0" class="alert">
                    No hay tareas pendientes.
                  </div>
                  <div v-else class="table-responsive">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th>Tipo</th>
                          <th>Documento</th>
                          <th>Esquema</th>
                          <th>Fecha límite</th>
                          <th>Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="tarea in tareasFiltradas" :key="tarea.id">
                          <td>
                            <span class="badge" :class="getBadgeClass(tarea.tipo)">
                              {{ getTipoLabel(tarea.tipo) }}
                            </span>
                          </td>
                          <td class="text-sm">{{ tarea.datos_tarea?.nombre_documento || tarea.nombre_documento || tarea.titulo || '-' }}</td>
                          <td class="text-sm">{{ tarea.datos_tarea?.esquema_nombre || '-' }}</td>
                          <td class="text-sm">{{ formatDateTime(tarea.fecha_limite || tarea.caducidad) || '-' }}</td>
                          <td class="text-end">
                            <button v-if="tarea.tipo === 'firma_pantalla'" 
                              class="btn btn-success btn-sm" 
                              @click="abrirFirma(tarea)">
                              Firmar en pantalla
                            </button>
                            <div v-else-if="tarea.tipo === 'aprobacion' || tarea.tipo === 'aprobacion_avanzada'" class="btn-group">
                              <button class="btn btn-success btn-sm" 
                                @click="aprobarDesdeTarea(tarea)"
                                :disabled="procesandoAprobacion">
                                <span v-if="procesandoAprobacion" class="spinner-border spinner-border-sm me-1"></span>
                                Aprobar
                              </button>
                              <button class="btn btn-danger btn-sm" 
                                @click="abrirModalRechazarTarea(tarea)"
                                :disabled="procesandoAprobacion">
                                Rechazar
                              </button>
                              <button class="btn btn-primary btn-sm" 
                                @click="verDocumento(tarea)">
                                Ver
                              </button>
                            </div>
                            <button v-else-if="tarea.tipo === 'caducidad'" 
                              class="btn btn-primary btn-sm" 
                              @click="verDocumento(tarea)">
                              Ver documento
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal de firma -->
        <div v-if="mostrarModalFirma" class="modal fade show" tabindex="-1" style="display:block; background: rgba(0,0,0,0.4);">
          <div class="modal-dialog modal-fullscreen-md-down" style="max-width:90vw;">
            <div class="modal-content">
              <div class="modal-header">
                <div>
                  <h5 class="modal-title">Firmar documento</h5>
                  <small class="text-muted d-block">Tarea ID: {{ tareaSeleccionada?.id }}</small>
                  <small class="text-muted d-block">{{ tareaSeleccionada?.datos_tarea?.nombre_documento || tareaSeleccionada?.nombre_documento || '-' }}</small>
                </div>
                <button type="button" class="btn-close" @click="cerrarModal"></button>
              </div>
              <div class="modal-body">
                <div class="row g-3">
                  <div class="row col-lg-9">
                    <div class=" col-lg-6 col-12 mb-3">
                      <div v-if="cargandoPdf" class="d-flex justify-content-center align-items-center border rounded" style="min-height:240px;">
                        <div class="spinner-border text-primary" role="status"></div>
                        <span class="ms-2 text-muted">Cargando documento...</span>
                      </div>
                      <div v-else-if="errorPdf" class="alert alert-danger">
                        No se pudo cargar el documento. {{ errorPdf }}
                      </div>
                      <div v-else class="pdf-wrapper border rounded" style="overflow:auto; max-height:420px;">
                        <iframe
                          v-if="pdfDataUrl"
                          :src="pdfDataUrl + '#toolbar=0&navpanes=0&scrollbar=0'"
                          style="width:100%; min-height:400px; border: none;"
                        />
                      </div>
                    </div>
                    <div class=" col-lg-6 col-12 signature-wrapper">
                      <canvas ref="canvasRef" class="signature-canvas"
                        @mousedown="iniciarTrazo"
                        @mousemove="trazar"
                        @mouseup="terminarTrazo"
                        @mouseleave="terminarTrazo"
                        @touchstart.prevent="iniciarTrazo"
                        @touchmove.prevent="trazar"
                        @touchend.prevent="terminarTrazo">
                      </canvas>
                      <div class="text-muted small mt-2">Firma con el ratón o el dedo.</div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="card h-100">
                      <div class="card-body d-flex flex-column">
                        <h6>Detalles</h6>
                        <ul class="list-unstyled small flex-grow-1">
                          <li><strong>Documento:</strong> {{ tareaSeleccionada?.datos_tarea?.nombre_documento || tareaSeleccionada?.nombre_documento || '-' }}</li>
                          <li><strong>Esquema:</strong> {{ tareaSeleccionada?.esquema_id || '-' }}</li>
                          <li><strong>Registro:</strong> {{ tareaSeleccionada?.registro_id || '-' }}</li>
                          <li><strong>Fecha límite:</strong> {{ formatDateTime(tareaSeleccionada?.fecha_limite || tareaSeleccionada?.caducidad) || '-' }}</li>
                        </ul>
                        <div class="d-flex gap-2">
                          <button class="btn btn-outline-secondary w-50" @click="limpiarFirma" :disabled="enviandoFirma">Limpiar</button>
                          <button class="btn btn-success w-50" @click="enviarFirma" :disabled="enviandoFirma">
                            <span v-if="enviandoFirma" class="spinner-border spinner-border-sm me-2" role="status"></span>
                            Enviar firma
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal Rechazar Documento -->
        <div v-if="mostrarModalRechazarTarea" class="modal fade show" tabindex="-1"
          style="display: block; background: rgba(0,0,0,0.3);">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Rechazar Documento</h5>
                <button type="button" class="btn-close" @click="mostrarModalRechazarTarea = false"></button>
              </div>
              <div class="modal-body">
                <div class="mb-3">
                  <label class="form-label">Motivo del rechazo <span class="text-danger">*</span></label>
                  <textarea class="form-control" v-model="motivoRechazo" rows="4" 
                    placeholder="Describe el motivo del rechazo..." required></textarea>
                </div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-secondary" @click="mostrarModalRechazarTarea = false">Cancelar</button>
                <button class="btn btn-danger" @click="rechazarDesdeTarea" 
                  :disabled="!motivoRechazo || procesandoAprobacion">
                  <span v-if="procesandoAprobacion" class="spinner-border spinner-border-sm me-2" role="status"></span>
                  Rechazar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script setup>
import { onMounted, ref, computed, nextTick, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import HeaderMenu from '@/components/HeaderMenu.vue'
import axiosInstance from '@/axios'

const router = useRouter()

const tareas = ref([])
const cargando = ref(false)
const tareaSeleccionada = ref(null)
const mostrarModalFirma = ref(false)
const canvasRef = ref(null)
const ctx = ref(null)
const dibujando = ref(false)
const enviandoFirma = ref(false)
const cargandoPdf = ref(false)
const errorPdf = ref('')
const pdfDataUrl = ref('')
const firmaAspectRatio = ref(0.5) // alto / ancho

const resizeHandler = () => ajustarCanvas()

const tareasFiltradas = computed(() => {
  // Filtrar por tipo de tarea: firma_pantalla, aprobacion, aprobacion_avanzada, caducidad
  return (tareas.value || []).filter(t => {
    const tipo = (t.tipo || '').toLowerCase()
    return tipo === 'firma_pantalla' || tipo === 'aprobacion' || tipo === 'aprobacion_avanzada' || tipo === 'caducidad'
  })
})

const procesandoAprobacion = ref(false)
const tareaParaRechazar = ref(null)
const motivoRechazo = ref('')
const mostrarModalRechazarTarea = ref(false)

const getTipoLabel = (tipo) => {
  const labels = {
    'firma_pantalla': 'Firma en pantalla',
    'aprobacion': 'Aprobación',
    'aprobacion_avanzada': 'Aprobación avanzada',
    'caducidad': 'Caducidad',
    'firma_vidsigner': 'Firma VidSigner'
  }
  return labels[tipo] || tipo
}

const getBadgeClass = (tipo) => {
  const classes = {
    'firma_pantalla': 'bg-primary',
    'aprobacion': 'bg-warning',
    'aprobacion_avanzada': 'bg-info',
    'caducidad': 'bg-danger',
    'firma_vidsigner': 'bg-info'
  }
  return classes[tipo] || 'bg-secondary'
}

const aprobarDesdeTarea = async (tarea) => {
  if (!tarea.esquema_id || !tarea.registro_id) return

  const esAprobacionAvanzada = (tarea.tipo || '').toLowerCase() === 'aprobacion_avanzada'
  const url = esAprobacionAvanzada
    ? `/api/aprobacionAvanzada/aprobar/${tarea.esquema_id}/${tarea.registro_id}`
    : `/api/aprobarDocumento/${tarea.esquema_id}/${tarea.registro_id}`

  procesandoAprobacion.value = true
  try {
    const response = await axiosInstance.post(url, esAprobacionAvanzada ? {} : undefined)
    if (response.data.success) {
      showNotification('Documento aprobado correctamente', 'alert-success')
      await cargarTareas()
    }
  } catch (error) {
    const mensaje = error.response?.data?.message || 'Error al aprobar el documento'
    showNotification(mensaje, 'alert-danger')
  } finally {
    procesandoAprobacion.value = false
  }
}

const abrirModalRechazarTarea = (tarea) => {
  tareaParaRechazar.value = tarea
  motivoRechazo.value = ''
  mostrarModalRechazarTarea.value = true
}

const rechazarDesdeTarea = async () => {
  if (!tareaParaRechazar.value || !motivoRechazo.value.trim()) return

  const tarea = tareaParaRechazar.value
  const esAprobacionAvanzada = (tarea.tipo || '').toLowerCase() === 'aprobacion_avanzada'
  const url = esAprobacionAvanzada
    ? `/api/aprobacionAvanzada/rechazar/${tarea.esquema_id}/${tarea.registro_id}`
    : `/api/rechazarDocumento/${tarea.esquema_id}/${tarea.registro_id}`
  const body = { motivo_rechazo: motivoRechazo.value.trim() }

  procesandoAprobacion.value = true
  try {
    const response = await axiosInstance.post(url, body)
    if (response.data.success) {
      showNotification('Documento rechazado correctamente', 'alert-success')
      mostrarModalRechazarTarea.value = false
      motivoRechazo.value = ''
      tareaParaRechazar.value = null
      await cargarTareas()
    }
  } catch (error) {
    const mensaje = error.response?.data?.message || 'Error al rechazar el documento'
    showNotification(mensaje, 'alert-danger')
  } finally {
    procesandoAprobacion.value = false
  }
}

const verDocumento = (tarea) => {
  if (tarea.esquema_id && tarea.registro_id) {
    router.push(`/esquema/${tarea.esquema_id}/registro/${tarea.registro_id}`)
  }
}

// Notificaciones
const notifications = ref([])

const showNotification = (message, type) => {
  const notification = {
    message,
    class: type,
  }
  notifications.value.push(notification)

  // Cerrar la notificación automáticamente después de 2 segundos
  setTimeout(() => {
    closeNotification(notifications.value.indexOf(notification))
  }, 2000)
}

const closeNotification = (index) => {
  notifications.value.splice(index, 1)
}

const formatDateTime = (value) => {
  if (!value) return ''
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleString()
}

const cargarTareas = async () => {
  cargando.value = true
  try {
    const response = await axiosInstance.get('/api/tareasFirma/pendientes')
    tareas.value = response.data?.tareas || []
  } catch (error) {
    console.error('Error al cargar tareas:', error)
  } finally {
    cargando.value = false
  }
}

const ajustarCanvas = () => {
  const canvas = canvasRef.value
  if (!canvas) return
  const parent = canvas.parentElement
  canvas.width = parent.clientWidth
  const alturaCalculada = Math.round(canvas.width * firmaAspectRatio.value)
  canvas.height = Math.max(220, alturaCalculada)
  ctx.value = canvas.getContext('2d')
  ctx.value.lineWidth = 2
  ctx.value.lineJoin = 'round'
  ctx.value.lineCap = 'round'
  ctx.value.strokeStyle = '#000'
}

const obtenerPosicion = (evento) => {
  const canvas = canvasRef.value
  const rect = canvas.getBoundingClientRect()
  let x, y
  if (evento.touches && evento.touches.length > 0) {
    x = evento.touches[0].clientX - rect.left
    y = evento.touches[0].clientY - rect.top
  } else {
    x = evento.clientX - rect.left
    y = evento.clientY - rect.top
  }
  return { x, y }
}

const iniciarTrazo = (evento) => {
  if (!ctx.value) return
  dibujando.value = true
  const { x, y } = obtenerPosicion(evento)
  ctx.value.beginPath()
  ctx.value.moveTo(x, y)
}

const trazar = (evento) => {
  if (!dibujando.value || !ctx.value) return
  const { x, y } = obtenerPosicion(evento)
  ctx.value.lineTo(x, y)
  ctx.value.stroke()
}

const terminarTrazo = () => {
  dibujando.value = false
}

const limpiarFirma = () => {
  if (!ctx.value || !canvasRef.value) return
  ctx.value.clearRect(0, 0, canvasRef.value.width, canvasRef.value.height)
}

const abrirFirma = async (tarea) => {
  tareaSeleccionada.value = tarea
  actualizarAspectRatio()
  mostrarModalFirma.value = true
  await nextTick()
  await cargarPdfTarea()
  ajustarCanvas()
}

const cerrarModal = () => {
  mostrarModalFirma.value = false
  limpiarFirma()
  tareaSeleccionada.value = null
  pdfDataUrl.value = ''
  errorPdf.value = ''
}

const actualizarAspectRatio = () => {
  const pos = tareaSeleccionada.value?.datos_tarea?.posicion_firma
  if (pos?.ancho && pos?.alto && Number(pos.ancho) > 0 && Number(pos.alto) > 0) {
    firmaAspectRatio.value = Number(pos.alto) / Number(pos.ancho)
  } else {
    firmaAspectRatio.value = 0.5
  }
}

const enviarFirma = async () => {
  if (!tareaSeleccionada.value || !canvasRef.value || enviandoFirma.value) return
  const firmaBase64 = canvasRef.value.toDataURL('image/png')
  enviandoFirma.value = true
  try {
    await axiosInstance.post(`/api/firmarEnPantalla/${tareaSeleccionada.value.id}`, { firma_base64: firmaBase64 })
    await cargarTareas()
    cerrarModal()
  } catch (error) {
    console.error('Error al enviar firma:', error)
  } finally {
    enviandoFirma.value = false
  }
}

const cargarPdfTarea = async () => {
  if (!tareaSeleccionada.value?.esquema_id || !tareaSeleccionada.value?.registro_id) {
    errorPdf.value = 'Faltan datos de esquema o registro'
    return
  }
  cargandoPdf.value = true
  errorPdf.value = ''
  pdfDataUrl.value = ''
  try {
    const resp = await axiosInstance.get(`api/ficheroRegistro/${tareaSeleccionada.value.esquema_id}/${tareaSeleccionada.value.registro_id}`)
    if (!resp.data?.base64) {
      throw new Error('No se recibió el archivo')
    }
    pdfDataUrl.value = `data:application/pdf;base64,${resp.data.base64}`
  } catch (err) {
    console.error('Error al cargar PDF de tarea:', err)
    errorPdf.value = err?.message || 'No se pudo cargar el documento'
  } finally {
    cargandoPdf.value = false
  }
}

onMounted(() => {
  cargarTareas()
  window.addEventListener('resize', resizeHandler)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', resizeHandler)
})
</script>

<style scoped>
.signature-wrapper {
  border: 1px dashed #ced4da;
  border-radius: 8px;
  padding: 8px;
  background: #fff;
  min-height: 320px;
}
.signature-canvas {
  width: 100%;
  height: 300px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  touch-action: none;
}
</style>

